import { Button, HStack, Text } from '@chakra-ui/react';
import React, { FC } from 'react';

import { Icon } from '@app/components/Icon';

interface Props {
  activePage: number;
  totalPages?: number;
  onNext: () => void;
  onPrev: () => void;
  hasNext?: boolean;
}

export const ListPagination: FC<Props> = ({
  activePage,
  totalPages,
  onNext,
  onPrev,
  hasNext = true
}) => {
  return (
    <HStack
      width="100%"
      mt="24px"
      justify="center"
      fontSize="16px"
      lineHeight="26px"
      gap={4}
    >
      <Button
        variant="rowCompact"
        sx={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          visibility: activePage !== 0 ? 'visible' : 'hidden',
          '&:hover': { color: 'neutral.100' },
          color: 'neutral.300'
        }}
        onClick={onPrev}
        disabled={activePage === 0}
      >
        <Icon
          name="arrowLeft"
          style={{ color: 'inherit', transition: 'unset' }}
        />
        <Text color="inherit">Prev</Text>
      </Button>
      <Text
        color="neutral.300"
        sx={{
          border: '1px solid',
          borderColor: 'neutral.700',
          borderRadius: '8px',
          padding: '8px 16px'
        }}
      >
        Page {activePage + 1} {totalPages ? `of ${totalPages}` : ''}
      </Text>
      <Button
        variant="rowCompact"
        sx={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          visibility:
            !totalPages || activePage !== totalPages - 1
              ? hasNext
                ? 'visible'
                : 'hidden'
              : 'hidden',
          '&:hover': { color: 'neutral.100' },
          color: 'neutral.300'
        }}
        onClick={onNext}
        disabled={totalPages ? activePage === totalPages - 1 : false}
      >
        <Text color="inherit">Next</Text>
        <Icon
          name="arrowRight"
          style={{ color: 'inherit', transition: 'unset' }}
        />
      </Button>
    </HStack>
  );
};
